import React, { useCallback } from 'react';
import Form from 'react-jsonschema-form';
import { Button } from 'reactstrap';
import ReactDOM from 'react-dom';
import axios from 'axios';

import MeterPointSelector from '../../../MeterPointSelector/MeterPointSelector';
import { changeOfEnergisationSchema, changeOfEnergisationUISchema } from '../../schemas/changeOfEnergisationSchema';
import { useProcessForm } from '../../hooks/useProcessForm';
import ExpiringAlert from '../../../ExpiringAlert/ExpiringAlert';

const ChangeOfEnergisationForm = ({ onClose, initialData }) => {
  const { formContext, updateFormContext, isLoading, setIsLoading } = useProcessForm(initialData || {});

  const handleChange = useCallback(
    ({ formData }) => {
      updateFormContext(formData);
    },
    [updateFormContext],
  );

  const transformErrors = useCallback((errors) => {
    return errors.map((error) => {
      switch (error.property) {
        case '.mpan_core':
          return { ...error, message: 'MPAN Core is a required property' };
        case '.requested_energisation_status':
          return { ...error, message: 'Requested Energisation Status is a required property' };
        default:
          return error;
      }
    });
  }, []);

  const transformFormDataToPayload = (formData) => {
    return {
      mpan_core: parseInt(formData.mpan_core, 10),
      requested_energisation_status: formData.requested_energisation_status,
    };
  };

  const uiSchemaWithWidgets = {
    ...changeOfEnergisationUISchema,
    mpan_core: {
      ...changeOfEnergisationUISchema.mpan_core,
      'ui:widget': (props) => <MeterPointSelector {...props} placeholder='Select MPAN' />,
    },
  };

  const loadingIcon = isLoading ? (
    <span>
      <i className='fa fa-circle-o-notch fa-spin'></i>{' '}
    </span>
  ) : null;

  return (
    <div className='change-of-energisation-form'>
      <Form
        schema={changeOfEnergisationSchema}
        uiSchema={uiSchemaWithWidgets}
        formContext={formContext}
        formData={formContext}
        transformErrors={transformErrors}
        showErrorList={false}
        onSubmit={({ formData }) => {
          setIsLoading(true);
          const payload = transformFormDataToPayload(formData);

          axios
            .post('/publishMessage', payload, {
              headers: {
                Authorization: `Bearer ${localStorage.token}`,
              },
              params: { queue: 'BOP.Dataflows.StartEnergisationChange' },
            })
            .then((response) => {
              setIsLoading(false);
              if (response.data === 'Message sent') {
                ReactDOM.render(
                  <ExpiringAlert color='success' message='Change of Energisation request submitted successfully!' />,
                  document.getElementById('alert').appendChild(document.createElement('div')),
                );
                onClose();
              } else {
                ReactDOM.render(
                  <ExpiringAlert color='danger' message={response.data.message || 'Error submitting request'} />,
                  document.getElementById('alert').appendChild(document.createElement('div')),
                );
              }
            })
            .catch((error) => {
              setIsLoading(false);
              // eslint-disable-next-line no-console
              console.error('Error submitting change of energisation request:', error);
              ReactDOM.render(
                <ExpiringAlert color='danger' message='Error submitting request. Request logged to console.' />,
                document.getElementById('alert').appendChild(document.createElement('div')),
              );
            });
        }}
        onChange={handleChange}
      >
        <div>
          <Button type='submit' disabled={isLoading} color='primary'>
            {isLoading && loadingIcon}Submit Request
          </Button>
          &nbsp;&nbsp;&nbsp;
          <Button type='button' onClick={onClose}>
            Cancel
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default ChangeOfEnergisationForm;
